import { CallToAction } from 'components/CallToAction'
import React from 'react'
import cntl from 'cntl'
import { prepareData } from 'utils/googleData'

export const heading = (size = 'lg', color = 'primary', classes = '') => {
    const options = {
        lg: 'text-5xl md:text-7xl',
        md: 'text-4xl lg:text-5xl 2xl:text-5xl',
        subtitle:
            'text-xl xl:text-2xl leading-tight font-semibold mt-2 md:mt-3 text-primary/50 dark:text-primary-dark/50',
        sm: 'text-[18px] md:text-[20px] leading-tight md:text-xl font-semibold mt-2 md:mt-3 opacity-75',
    }
    return cntl`
        m-0
        text-center
        ${options[size]}
        text-${color}
        ${classes}
    `
}

export const section = (className = '') => cntl`
    max-w-screen-2xl
    mx-auto
    mt-4
    mb-16
    md:my-16
    px-4
    ${className}
`

const ApproachStat = ({ title, description }) => {
    return (
        <li className="p-6">
            <div className="bg-gradient-to-t from-primary to-white bg-clip-text text-2xl font-bold text-transparent lg:text-4xl">
                {title}
            </div>
            <div className="text-17px mt-2 font-semibold">{description}</div>
        </li>
    )
}

export function PricingApproach(props) {
    const {
        enable,
        title,
        subtitle,
        description,
        cta,
        direction,
        style,
        className,
        gatsbyImage,
        features,
        gatsbyImage2,
    } = prepareData({ props })
    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    return (
        <section dir={direction} className={section('text-center')}>
            <div className={`dark w-full rounded-lg bg-primary px-4 py-16 dark:bg-primary ${style}`}>
                <h2 className={heading('md', 'white')} dangerouslySetInnerHTML={{ __html: title }}></h2>
                {subtitle && <h3 className={heading('sm', 'tan')}>{subtitle}</h3>}
                {features?.length > 0 && features[0].description != '' && features[0].enable != 'false' && (
                    <ul className="m-0 my-8 grid list-none divide-y-1 divide-dashed divide-gray-accent-light p-0 text-white sm:my-20 sm:grid-cols-3 sm:divide-y-0 sm:divide-x-1">
                        {features.map((feature, index) => {
                            return (
                                <ApproachStat
                                    key={index}
                                    description={feature?.description}
                                    title={feature?.name}
                                    {...feature}
                                />
                            )
                        })}
                    </ul>
                )}
                {description != '' && (
                    <div className={`bg-blue px-8 pt-12 pb-16 text-white md:px-16 ${className}`}>
                        <h4 className="mb-8 text-4xl leading-tight md:mb-4">{description}</h4>
                    </div>
                )}
                {cta?.url != '' && (
                    <CallToAction type="outline" width="56" href={cta?.url}>
                        {cta?.text}
                    </CallToAction>
                )}
            </div>
        </section>
    )
}
export default PricingApproach
